<af-main-container #mainContainer
                   [title]="title"
                   [breadcrumbCustomizer]="breadcrumbCustomizer"
                   [filterNavigationPath]="Path.CONTACT_DETAILS"
                   [specialFilter]="filter"
                   [tabPathToTab]="tabPathToTab"
                   [queryParamsHandling]="'merge'"
                   [buttonLabel]="canDelete ? ('i18n_af_buttonDelete' | translate) : null"
                   buttonType="secondary"
                   buttonColor="accent"
                   (buttonClickListener)="deleteContact()"
                   spinnerIds="initial">
    @if (contactDetails) {
        <af-incident-contact class="w-100 mt-24 overflow-y-scroll"
                             [contactDetails]="contactDetails"
                             [allowedTabs]="allowedTabs"/>
    }
</af-main-container>
